
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import {
  CompleteUpload,
  MultipartUploadCompleteResponse,
  RegisterArguments,
  RegisterResponse,
  RetrieveFileByIdResponse,
} from './types';
import { axiosInstance } from "../axios-instance";

class FileStorage {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  multiPartRegister(input: RegisterArguments): Promise<AxiosResponse<RegisterResponse>> {
    const { queryParameters, body } = input;
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<RegisterResponse>(`${this.baseUrl}/multipart/register`, body, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  multiPartCompleteUpload(
    input: CompleteUpload,
  ): Promise<AxiosResponse<MultipartUploadCompleteResponse>> {
    const { queryParameters } = input;
    const accessToken = localStorage.getItem('accessToken');
    const request: any = {
      url: `${this.baseUrl}/multipart/${queryParameters.id}/completeUpload`,
      params: queryParameters,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axiosInstance(request);
  }

  retrieveMetaDataById(id: string): Promise<AxiosResponse<RetrieveFileByIdResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<RetrieveFileByIdResponse>(
      `${this.baseUrl}/files/${id}/metadata?partyNumber=CAT`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}

export default FileStorage;
